export const ROOM_TYPE = {
    SUPPORT_CLIENT: 3,
    AGENCY: 2,
    TEAM: 1
};
export const MEMBER_STATUS = {
    ACTIVE: 1,
    BLOCKED: 2,
    DELETED: 3
}
export const MEMBER_TYPE = {
    ADV: 1,
    ADV_REFERER: 2,
    CLIENT: 3,
    CLIENT_REFERER: 4,
    AGENCY: 5,
    AGENCY_REFERER: 6,
    AGENCY_LEAD: 7
};

export const FIREBASE_ROOT_REF='Chats'

export const CHAT_MSG_STATUS = {
    DELETE_FOR_ME: 'delete-for-me',
    DELETE_FOR_ALL: 'delete-for-all',
    EDITED: 'edited',
}